import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { mediaConfined, mediaTopBarVisible } from '@xing-com/layout-tokens';
import { xdlColorText, spaceXL, spaceXXL, space3XL } from '@xing-com/tokens';
import { Hero as BaseHero } from '@xing-com/typography';

const Hero = styled(BaseHero)`
  padding-top: ${spaceXXL};
  text-align: center;
  color: ${xdlColorText};
  margin: 0 20px ${spaceXL} 20px;
  text-wrap: balance;

  @media ${mediaConfined} {
    padding-top: ${space3XL};
    margin-bottom: ${spaceXL};
  }

  @media ${mediaTopBarVisible} {
    display: none;
  }
`;

export const Title: React.FC = () => {
  return (
    <Hero size="small" sizeConfined="medium">
      <FormattedMessage id="JOBS_SEARCH_AI_HEADLINE" />
    </Hero>
  );
};
